<template>
  <div v-if="showForm">
    <v-row no-gutters>
      <span class="body-2 font-weight-medium">Subscription Summary</span>
    </v-row>
    <v-row no-gutters>
      <span class="body-2">
        Please review your subscription details before finalizing.
      </span>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="body-1 font-weight-medium">Contact</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="body-2 font-weight-medium">Parish Council: </span>
                <span class="body-2">{{`${DATA.parish.organisation_title}`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2 font-weight-medium">Your Name: </span>
                <span class="body-2">{{`${DATA.personal.forename} ${DATA.personal.surname}`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2 font-weight-medium">Position: </span>
                <span class="body-2">{{`${DATA.personal.position}`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2">{{`${DATA.council.address}`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="DATA.council && DATA.council.address2.length !== 0">
                <span class="body-2">{{`${DATA.council.address2}`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle v-if="DATA.council.town.length !== 0">
                <span class="body-2">{{`${DATA.council.town}`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2">{{`${DATA.council.postcode}`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2">{{`${DATA.council.district}`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2">{{`${DATA.council.phone}`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2">{{`${DATA.council.email}`}}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
      <v-col cols="6">
        <v-list dense>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="body-1 font-weight-medium">Account</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="body-2 font-weight-medium">Type: </span>
                <span class="body-2" v-if="DATA.type === 'SUBSCRIPTION'">Annual Subscription</span>
                <span class="body-2" v-else>Free 90 Day Trial</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2 font-weight-medium">Subtotal: </span>
                <span class="body-2">{{`£${ parseFloat(parishSubtotal).toFixed(2) }`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2 font-weight-medium">VAT: </span>
                <span class="body-2">{{`£${ parseFloat(parishVat).toFixed(2) }`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2 font-weight-medium">Total: </span>
                <span class="body-2">{{`£${ parseFloat(parishTotal).toFixed(2) }`}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2" v-if="discountPercentage !== 0">{{ discountPercentage + '% Discount applied'}}</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2" v-if="DATA.type === 'TRIAL'">You will not be charged until your Trial ends.</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <span class="body-1 font-weight-medium">Licencing</span>
              </v-list-item-title>
              <v-list-item-subtitle>
                <span class="body-2 font-weight-medium">PSGA: </span>
                <span class="body-2" v-if="DATA.psma.has">{{`${DATA.psma.number}`}}</span>
                <span class="body-2" v-else>N/A</span>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <span class="body-2" v-if="DATA.apgb.has">Already has an APGB licence</span>
                <span class="body-2" v-else-if="DATA.apgb.wants">Wants an APGB licence</span>
                <span class="body-2" v-else>Does not want an APGB licence</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "StepTen",
    components: {},
    props: {
      showForm : {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {}
    },
    computed: {
      ...mapGetters({
        DATA: 'GET_ALL_DATA'
      }),
      parishSubtotal() {
        if (this.DATA.parish.price) {
          return this.DATA.parish.price - this.computedDiscount;
        }
      },
      parishVat() {
        if (this.DATA.parish) {
          return (this.parishSubtotal / 5);
        }
      },
      parishTotal() {
        if (this.DATA.parish) {
          return this.parishSubtotal + this.parishVat;
        }
      },
      computedDiscount() {
        if (this.DATA.coupon && this.DATA.coupon.id) {
          return (this.DATA.coupon.percent_off / 100) * this.DATA.parish.price;
        } else {
          if (this.DATA.type === 'SUBSCRIPTION') {
            return (this.DATA.parish.price / 10);
          } else {
            return 0;
          }
        }
      },
      discountPercentage() {
        if (this.DATA.coupon && this.DATA.coupon.id) {
          return this.DATA.coupon.percent_off;
        } else {
          if (this.DATA.type === 'SUBSCRIPTION') {
            return 10;
          } else {
            return 0;
          }
        }
      }
    },
    methods: {}
  }
</script>
